import { Component, input } from '@angular/core';
import { LineInputs } from '@charts';
import { LineChartComponent } from "../line-chart";

@Component({
  selector: 'ui-rsabt-temperature-chart',
  imports: [LineChartComponent],
  template: ` <ui-line-chart [lineInputs]="lineInputs()" /> `,
})
export class RsabtTemperatureChartComponent {
  lineInputs = input.required<LineInputs>();
}
